<!-- @veltra/icons generated sha256:a38c06b0ba0caf53 gen:8 source:src/svg/normal/discount.svg -->
<script setup lang="ts">
defineOptions({ name: 'Discount' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M2 3.015V7.95a1 1 0 0 0 .293.707l6.133 6.133a1 1 0 0 0 1.415 0l4.95-4.95a1 1 0 0 0 0-1.414L8.656 2.293A1 1 0 0 0 7.95 2H3.015C2.462 2 2 2.462 2 3.015m12.083 6.119L7.95 3H4.023A1.04 1.04 0 0 0 3 4.023V7.95l6.133 6.133zM7.84 7.839A2 2 0 1 0 5.01 5.01a2 2 0 0 0 2.83 2.83M5.718 5.717a1 1 0 1 1 1.414 1.415 1 1 0 0 1-1.414-1.415"
    />
  </svg>
</template>
